<template>
  <div class="join-us">
    

    <div class="content-main">
      <div
        class="box-item"
        v-for="(item, index) in mydata.articleListArr"
        :key="index"
        @click="joinUsButton(item.id)"
        style="cursor: pointer"
      >
        <p>{{ item.title }}</p>
        <p>{{ dayjs(item.release_time * 1000).format("YYYY-MM-DD") }}</p>
        <!-- <p>学习顾问课程规划师</p>
        <p>2024-5-22</p> -->
      </div>
    </div>

    <!--分页 -->
    <div class="gl-pagination">
      <el-pagination
        v-model:currentPage="mydata.pageObj.currentPage"
        v-model:page-size="mydata.pageObj.pageSize"
        :total="mydata.pageObj.total"
        layout="prev, pager, next"
        pager-count="4"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script setup>
import { reactive } from "vue";
import { useRouter, useRoute } from "vue-router";

import dayjs from "dayjs";
// 引入接口
import { articleList } from "@/api/home/index.js";
// 引入接口
import { getUrlId } from "@/utils/slide.js";

const router = useRouter();
const route = useRoute();

const mydata = reactive({
  currentPage3: "5",
  pageSize3: "100",
  small: false,
  background: false,
  disabled: false,
  //////

  path: "/layout/list/joinUsDetails",
  articleListArr: [], // 文章列表

  pageObj: {
    currentPage: 1, // 当前页数
    pageSize: 10, // 每页条数
    total: 0, // 总的条数
  },

  form: {
    // column_id: getUrlId(route.path), // 栏目id值
    column_id: 38, // 栏目id值
    // search: "", // 搜索查询
    // stage: "", //学段
    // theme: "", //主题
    // subject: "", //学科
  },
});

// 当前页数改变事件
function handleCurrentChange(val) {
  // 查询
  articleListFn();
}

// 获取文章列表
function articleListFn() {
  articleList({
    ...mydata.form,
    page: String(mydata.pageObj.currentPage),
    psize: String(mydata.pageObj.pageSize),
  }).then((res) => {
    // console.log(4, res.data);
    // 文章列表
    mydata.articleListArr = res.data.list;
    // 总的条数
    mydata.pageObj.total = res.data.count;
  });
}

// 调用函数
articleListFn();

//点击事件
function joinUsButton(id) {
  router.push({
    path: mydata.path,
    query: { id },
  });
}
</script>

<style scoped lang="scss">
.join-us {
  
  padding-top:16px;
  // padding-bottom: 40px;
 
 

  /////内容
  // .join-content {
  //   height: 343px;
  //   border: 1px solid red;
  // }

  .content-main {
    width: 343px;
    margin:0 auto;
    // height: 780px;
    // border: 1px solid red;
    // margin-top: 30px;

    .box-item {
      height: 68px;
      border-bottom: 1px solid #dcdee2;
      // display: flex;
      // justify-content: space-between;
      margin-bottom: 20px;
      
      position: relative;
      > p:nth-of-type(1) {
        // width: 768px;
        //  border:1px dashed red;
        // line-height: 46px;
        font-size: 16px;
        font-weight: 700;
        color: #333333;
        // margin-left: 15px;

        white-space: nowrap; //不折行
        text-overflow: ellipsis; //文本溢出 用省略号显示
        overflow: hidden;
      }
      > p:nth-of-type(2) {
        // width:119px;

        // border:1px solid red;
        line-height: 46px;
        font-size: 14px;
        font-weight: 400;
        color: #666666;
      }
    }
    .box-item:nth-last-of-type(1) {
      margin-bottom: 0px;
    }
    // .box-item::before {
    //   content: "";
    //   position: absolute;
    //   display: block;
    //   top: 9px;
    //   left: 0px;
    //   width: 7px;
    //   height: 7px;
    //   background-color: #dcdee2;
    //   border-radius: 3.5px;
    // }

    .box-item:hover {
      p {
        color: #009de0;
      }
    }
    // .box-item:hover::before {
    //     content: "";
    //     position: absolute;
    //     display: block;
    //     top: 9px;
    //     left: 0px;
    //     width: 7px;
    //     height: 7px;
    //     border-radius: 3.5px;
    //     background-color: #009de0 !important;
    //   }
  }

  //////////分页
  .paging {
    // margin: 0 auto;
    display: flex;
    justify-content: center;
    margin-top: 40px;
    margin-bottom: 40px;
    :deep(.el-button.is-plain) {
      margin-left: 24px;
    }
  }
  //最左边的箭头
  :deep(.btn-prev.is-first) {
    margin-right: 12px;
    background-color: #f5f6f7;
  }
  :deep(.btn-next) {
    background-color: #f5f6f7;
  }
  //每个页
  :deep(.number) {
    margin-right: 12px;
    // color:#BBBDBF;
    background-color: #f5f6f7;
  }
  //省略号
  :deep(.more.btn-quicknext.el-icon) {
    margin-right: 12px;
    background-color: #f9f9f9;
  }

  .demo-pagination-block + .demo-pagination-block {
    margin-top: 10px;
  }
  .demo-pagination-block .demonstration {
    margin-bottom: 16px;
  }
}
</style>